import { Component } from "../base/Component";
import { DomDragEvent, DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export interface DragListener extends EventListener<DragEvent> {
}

export class DragEvent extends Event<Component> {
    constructor(target: Component, domEvent?: Event | DomEvent) {
        super(target, domEvent);
    }

    public get altKey(): boolean {
        return this.domEvent.altKey;
    }

    public get ctrlKey(): boolean {
        return this.domEvent.ctrlKey;
    }

    public get shiftKey(): boolean {
        return this.domEvent.shiftKey;
    }

    public get domEvent(): DomDragEvent {
        return super.domEvent as DomDragEvent;
    }
}
